import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const TERMINALS_PATH = 'api/SchedulingTerminals';

export const getSchedulingTerminals = () => makeRequest(authFetch.get(TERMINALS_PATH));

export const getSchedulingTerminalsGrid = (params) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/Grid${getQueryParams(params)}`),
);

// Details by id
export const getSchedulingTerminal = (id) => makeRequest(authFetch.get(`${TERMINALS_PATH}/${id}`));

export const saveSchedulingTerminal = (schedulingTerminal) => makeRequest(
  authFetch.put(TERMINALS_PATH, schedulingTerminal),
);

export const deleteSchedulingTerminal = (id) => makeRequest(authFetch.delete(`${TERMINALS_PATH}/${id}`));

export const restoreSchedulingTerminal = (id) => makeRequest(authFetch.patch(`${TERMINALS_PATH}/${id}/restore`));

export const updateSchedulingTerminal = (terminalObj) => makeRequest(authFetch.put(TERMINALS_PATH, terminalObj));

// Terminal Counts
export const getSchedulingTerminalCountsPerMonth = (id, year, month) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/${id}/counts/${year}/${month}`),
);

export const getSchedulingTerminalCountsPerDate = (id, date) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/${id}/counts/${date}`),
);

export const setSchedulingTerminalCount = (id, data) => makeRequest(
  authFetch.put(`${TERMINALS_PATH}/${id}/counts`, data),
);

// Audit
export const getSchedulingTerminalsAudits = (id, params) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/${id}/Audits${getQueryParams(params)}`),
);

export const getSchedulingTerminalsAuditProperties = (id) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/${id}/Audits/Properties`),
);
export const getSchedulingTerminalsAuditUsers = (id) => makeRequest(
  authFetch.get(`${TERMINALS_PATH}/${id}/Audits/Users`),
);

// Statics
export const getTruckPoolTypes = () => makeRequest(authFetch.get(`${TERMINALS_PATH}/TruckPoolType`));

// Lookups
export const getSchedulingTerminalsLookup = () => makeRequest(authFetch.get(`${TERMINALS_PATH}/Lookup`));
export const useGetSchedulingTerminalsLookup = () => useQuery(['scheduling-terminals-lookup'], getSchedulingTerminalsLookup, CacheConfig.forever);
